/* unplugin-vue-components disabled */import script from "./auth-app-charge.vue?vue&type=script&setup=true&lang=js"
export * from "./auth-app-charge.vue?vue&type=script&setup=true&lang=js"

import "./auth-app-charge.vue?vue&type=style&index=0&id=651b6824&lang=scss&scoped=true"

import exportComponent from "D:\\igencloud_team\\ident-doc-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-651b6824"]])

export default __exports__